import { createContext, useContext, useState, type ReactNode } from "react";

export type Country = {
  code: string;
  id: string;
  name: string;
  flagIcon: string;
  fallbackicon: string;
  countryCode: string;
  currency: {
    code: string;
    name: string;
    symbol: string;
  };
};

type CountryContextType = {
  selectedCountry: Country | null;
  setSelectedCountry: (country: Country) => void;
};

const CountryContext = createContext<CountryContextType | undefined>(undefined);

const STORAGE_KEY = "selectedCountry";

export const CountryProvider = ({ children }: { children: ReactNode }) => {
  const [selectedCountry, setSelectedCountryState] = useState<Country | null>(
    () => {
      try {
        const savedCountry = localStorage.getItem(STORAGE_KEY);

        return savedCountry ? (JSON.parse(savedCountry) as Country) : null;
      } catch (err) {
        console.log("Failed to restore selected country:", err);
        return null;
      }
    },
  );

  const setSelectedCountry = (country: Country) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(country));
    } catch (err) {
      console.log("Failed to save selected country:", err);
    }

    setSelectedCountryState(country);
  };
  

  return (
    <CountryContext.Provider
      value={{
        selectedCountry,
        setSelectedCountry,
      }}
    >
      {children}
    </CountryContext.Provider>
  );
};

export const useCountry = () => {
  const context = useContext(CountryContext);

  if (!context) {
    throw new Error("useCountry must be used within a CountryProvider");
  }

  return context;
};

// import { createContext, useContext, useState, type ReactNode } from "react";

// export type Country = {
//   code: string;
//   id: string;
//   name: string;
//   flagIcon: string;
//   fallbackicon: string;
//   countryCode: string;
//   currency: {
//     code: string;
//     name: string;
//     symbol: string;
//   };
// };

// type CountryContextType = {
//   selectedCountry: Country | null;
//   setSelectedCountry: (country: Country) => void;
// };

// const CountryContext = createContext<CountryContextType | undefined>(undefined);

// export const CountryProvider = ({ children }: { children: ReactNode }) => {
//   const [selectedCountry, setSelectedCountry] = useState<Country | null>(null);

//   return (
//     <CountryContext.Provider value={{ selectedCountry, setSelectedCountry }}>
//       {children}
//     </CountryContext.Provider>
//   );
// };

// export const useCountry = () => {
//   const context = useContext(CountryContext);
//   if (!context) {
//     throw new Error("useCountry must be used within a CountryProvider");
//   }
//   return context;
// };
